"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TimestampFormatter", {
  enumerable: true,
  get: function get() {
    return _timestampFormatter.default;
  }
});
Object.defineProperty(exports, "VersionFormatter", {
  enumerable: true,
  get: function get() {
    return _versionFormatter.default;
  }
});
Object.defineProperty(exports, "PublicationInfo", {
  enumerable: true,
  get: function get() {
    return _publicationInfo.default;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _publicationInfo.PublicationInfo;
  }
});
Object.defineProperty(exports, "NameValueItem", {
  enumerable: true,
  get: function get() {
    return _nameValueItem.default;
  }
});

var _timestampFormatter = _interopRequireDefault(require("./timestamp-formatter"));

var _versionFormatter = _interopRequireDefault(require("./version-formatter"));

var _publicationInfo = _interopRequireWildcard(require("./publication-info"));

var _nameValueItem = _interopRequireDefault(require("./name-value-item"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-publication-info/dist/index.js
// module id = 18
// module chunks = 0